import Vue from "vue"
import Vuex from 'vuex'
Vue.use(Vuex)
import {getUserInfo} from "./../http/request";
const localStoragePlugin = store => {
  if (localStorage.getItem('vuex')) {
    store.replaceState(JSON.parse(localStorage.getItem('vuex')))
  }
  store.subscribe((mutation, state) => {
    localStorage.setItem('vuex', JSON.stringify(state))
  })
}

export default new Vuex.Store({
  namespaced: true,
  state: {
    nav: [],
    searchKey: "",
    step1: {},
    step2: {},
    step3: {},
    code:'',
    userInfo:{},
    token:'',
    searchText:'',
  },
  mutations: {
    set_nav(state, data) {
      state.nav = data
    },
    set_searchKey(state, data) {
      state.searchKey = data
    },
    setRegisterInfo(state, {step,data}) {
      state[step] = data
    },
    setCode(state, data) {
      state.code = data
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setToken(state, data) {
      state.token = data
      // Also save token to localStorage for initial auth checks
      if (data) {
        localStorage.setItem('token', data)
      } else {
        localStorage.removeItem('token')
      }
    },
    setSearchText(state, data) {
      state.searchText = data
    }
  },
  actions: {
    setNav({commit}, data) {
      commit('set_nav', data)
    },
    setSearchKey({commit}, data) {
      commit('set_searchKey', data)
    },
    async fetchUserInfo({ commit }) {
      try {
        const token = localStorage.getItem('token')
        if (token) {
          const response = await getUserInfo()
          let userData = response.data.data
          if (userData.expireTime) {
            const currentTime = new Date().getTime()
            const expireTime = new Date(userData.expireTime).getTime()
            if (currentTime > expireTime) {
              userData = {
                ...userData,
                expireTime: null
              }
            }
          }
          commit('setUserInfo', userData)
          return userData
        }
      } catch (error) {
        commit('setToken', null)
        commit('setUserInfo', {})
        throw error
      }
    }
  },
  plugins: [localStoragePlugin]
})